import React from 'react';
import PropTypes from 'prop-types';
import { formats } from 'utils';
import { isFusionNonHurricane } from 'utils/policyType';

import { Typography } from 'components/alf-design';

const getPolicyNumberDisplay = (policy) => {
  if (policy.isFusion) {
    return `${policy.policyNumber} | ${policy.policyNumber}N`;
  }

  return policy.policyNumber;
};

const LinkedPolicies = ({ policies }) =>
  policies
    .filter((p) => !isFusionNonHurricane(p))
    .map((p, i) => (
      <li
        key={p.policyNumber}
        data-testid={`policy-${i}`}
        className="py-[12px] border-b border-gray-200"
      >
        <Typography type="h3" component="span">
          {`${formats.capitalize(p.propertyStreet)}${
            p.propertyApt ? `, ${p.propertyApt}` : ''
          }, ${formats.capitalize(p.propertyCity)}, ${p.propertyState} ${formats.zipFormat(
            p.propertyZip,
          )}`}
        </Typography>
        <Typography type="caption1" className="mt-[4px] block">
          {getPolicyNumberDisplay(p)}
        </Typography>
      </li>
    ));

LinkedPolicies.propTypes = {
  policies: PropTypes.array,
};

export default LinkedPolicies;
